import * as React from 'react';

import { FormElement, Field } from '@progress/kendo-react-form';
import { Label } from '@progress/kendo-react-labels';
import {  SchedulerFormEditorProps } from '@progress/kendo-react-scheduler';
import { JobDataItem } from '../../pages/Diary/Diary';
import EventContainerList, { GridDataItem } from './EventContainerList';
import { FormDateTimePicker, FormSwitch } from '../FormComps/FormComponents';
import './customForm.css';

export const CustomFormEditor = (props: SchedulerFormEditorProps, selectedItem: GridDataItem | null, setSelectedItem: (item: GridDataItem) => void, jobData: JobDataItem[], startDate: Date, endDate: Date | undefined, setStart: (date: Date) => void, setEnd: (date: Date) => void, allDay: boolean, setAll: (all: boolean) => void) => {

    // const currentDate = new Date();
    // const startDateTime = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 7, 30);
    // const endDateTime = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 17, 30);

    // startDate.setHours(7, 30);
    // endDate?.setHours(17, 30);

    return (
      <FormElement horizontal={true}>
        <div className="all-day-fix">
            <Label>All day</Label>
            <Field
                name={'allDay'}
                component={FormSwitch}
                defaultValue={allDay}
                onChange={(e) => setAll(e.value)} /> 
        </div>

        <Field
            name={'startDate'}
            disabled={allDay}
            component={FormDateTimePicker}
            label={'Start date:'}
            format={'dd/MM/yyyy HH:mm'}
            defaultValue={allDay ? undefined : startDate}
            onChange={(e) => setStart(e.value)}/>

            <Field
                name={'endDate'}
                disabled={allDay}
                component={FormDateTimePicker}
                label={'End date:'}
                format={'dd/MM/yyyy HH:mm'}
                defaultValue={allDay ? undefined : endDate}
                onChange={(e) => setEnd(e.value)} />

            <br />  

            <Label>Selected appointment:</Label>
            {
                selectedItem ? (
                    <div style={{maxWidth: "352px"}}>
                        <strong>{selectedItem.ref}</strong> - {selectedItem.description}
                    </div>
                ) : (
                    <div>Please select an appointment from the list</div>
                )
            }
            
            <br />  

            <EventContainerList 
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                onData={jobData} />
      </FormElement>
    );
};
